import React, { useContext } from 'react'
import Particles from 'react-particles-js'
import styled from 'styled-components'
import { ThemeContext } from 'styled-components'
import { MyLogo } from '../components/MyLogo'
import ParticlesDark from '../config/particlesjs-nyan-dark.json'
import ParticlesLight from '../config/particlesjs-nyan-light.json'
import { motion } from 'framer-motion'
import { EducationIcon } from '../AllSvg'
import { EducationList } from '../data/EducationList'
import { TabletSize } from '../responsive/TabletSize'
import Lottie from 'react-lottie'
import RocketLottile from '../assets/lottie-json/rocket-lottie.json'
import '../styles/particles.css'

const Wrapper = styled.div`
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  scrollbar-width: none; 
  &::-webkit-scrollbar {
    display: none;
  }
`
const AboutBox = styled.div`
  height: fit-content;
  position: absolute;
  top: 10%;
  right: 5%;
  bottom: 10%;
  left: 5%;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  padding: 20px 0px;
  ${TabletSize({ flexDirection: "column", top: "5%" })};
`
const AboutLeft = styled.div`
  width: 45%; 
  height: fit-content;
  display: flex;
  flex-direction: column;
  ${TabletSize({ width: "100%", margin: "50px 0px", })}
`
const AboutRight = styled.div`
  z-index: 1;
  height: fit-content;
  width: 45%;
  border: 2px solid ${props => props.theme.text};
  border-top-right-radius: 50px;
  border-bottom-left-radius: 50px;
  h2{
    color: ${props => props.theme.text};
    padding: 20px;
    text-decoration: underline;
  }
  p{
    color: ${props => props.theme.text};
    font-size: 20px;
    padding: 20px 30px;
    line-height: 40px;
    span{
      font-size: 50px;
    }
  }
  ${TabletSize({ width: "100%" })}
`
const EducationBox = styled.div`
  z-index: 1;
  padding: 10px 30px;
  margin: 20px 0px;
  background-color: ${props => props.theme.body};
  border: 2px solid ${props => props.theme.text};
  border-top-right-radius: 50px;
  border-bottom-left-radius: 50px;
  display: flex;
  flex-direction: column;
  &>div{
    padding-bottom: 5px;
    border-bottom: 2px solid ${props => props.theme.text};
    color: ${props => props.theme.text};
    h2{
      padding: 0px 10px;
    }
    svg{
      fill: ${props => props.theme.text};
    }
  }
  p{
    padding: 20px 0px;
    font-size: 20px;
    color: ${props => props.theme.text};
  }
  &:hover{
    border-top-right-radius: 0px;
    border-bottom-left-radius: 0px;
    border-top-left-radius: 50px;
    border-bottom-right-radius: 50px;
    transform: scale(1.08);
    transition: 0.2s;
    background-color: ${props => props.theme.text};
    &>div{
      border-bottom: 2px solid ${props => props.theme.body};
      color: ${props => props.theme.body};
      svg{
        fill: ${props => props.theme.body};
      }
    }
    p{
      color: ${props => props.theme.body};
    }
  }
  &:not(:hover){
    transition: 0.2s;
  }
  ${TabletSize({ margin: "10px 0px" })}
`
const EducationHeader = styled.div`
  display: flex;
  align-items: center;
`

export const AboutPage = () => {

  const theme = useContext(ThemeContext)
  const background = theme.isLight ? ParticlesLight : ParticlesDark;

  const defaultOptions = {
    loop: true,
    autoplay: true, 
    animationData: RocketLottile,
  };

  return (
    <Wrapper>
      <MyLogo/>
      <Particles 
        params={background} 
        canvasClassName={`${ theme.isLight ? "particlesLight" : "particlesDark" }`}
      />
      <AboutBox>
        <AboutLeft>
        {EducationList.map((item) => (
          <EducationBox>
            <EducationHeader>
              <EducationIcon height={50} width={50}/>
              <h2>{item.duration}</h2>
            </EducationHeader>
            <p>{item.school}</p>
          </EducationBox>
        ))}
        </AboutLeft>
        <AboutRight>
          <h2>About Me</h2>
          <p>
            <span>Hi</span> everyone, My name is Hem RithyBondeth.
          </p>
          <p>
            <span>I</span> am passionate about my work Because I love what I do. 
            I have a steady source of motivation that drives me to do my best,
            this passion led me to challenge myself daily and learn new skills
            that helped me to do better work. I soon become the go-to person for
            any software development needs.
          </p>
        </AboutRight>
      </AboutBox>
      <motion.div
      style={{ position: "absolute", top: -30, right: 0, zIndex: 1 }}
        drag
        animate={{ y: 0, x: 0 }}
        initial={{ y: 1000, x: 0 }}
        transition={{ type: "spring", stiffness: 60, damping: 10, delay: 0.5 }}
      >
        <Lottie
          options={defaultOptions} 
          height={"200px"} 
          width={"200px"}
        />
      </motion.div>
    </Wrapper>
  )
}
 